export enum TRANSACTION_TYPE {
  SELL = 'sell',
  BUY = 'buy',
}

export type RowObj = {
  id: string;
  fromCoin: string;
  fromVolume: number;
  toCoin: string;
  toVolume: number;
  type: TRANSACTION_TYPE;
  transactionDate: string; // ISO date
};

export const mockTransactions: RowObj[] = [
  {
    id: 'tx_001',
    fromCoin: 'USDT',
    fromVolume: 1000,
    toCoin: 'BTC',
    toVolume: 0.015,
    type: TRANSACTION_TYPE.BUY,
    transactionDate: '2025-12-10T09:15:00Z',
  },
  {
    id: 'tx_002',
    fromCoin: 'USDT',
    fromVolume: 500,
    toCoin: 'ETH',
    toVolume: 0.28,
    type: TRANSACTION_TYPE.BUY,
    transactionDate: '2025-12-11T14:32:00Z',
  },
  {
    id: 'tx_003',
    fromCoin: 'ETH',
    fromVolume: 0.1,
    toCoin: 'USDT',
    toVolume: 180,
    type: TRANSACTION_TYPE.SELL,
    transactionDate: '2025-12-12T08:05:00Z',
  },
  {
    id: 'tx_004',
    fromCoin: 'USDT',
    fromVolume: 300,
    toCoin: 'SOL',
    toVolume: 12,
    type: TRANSACTION_TYPE.BUY,
    transactionDate: '2025-12-13T16:48:00Z',
  },
  {
    id: 'tx_005',
    fromCoin: 'SOL',
    fromVolume: 5,
    toCoin: 'USDT',
    toVolume: 125,
    type: TRANSACTION_TYPE.SELL,
    transactionDate: '2025-12-14T11:20:00Z',
  },
  {
    id: 'tx_006',
    fromCoin: 'USDT',
    fromVolume: 200,
    toCoin: 'DOGE',
    toVolume: 2500,
    type: TRANSACTION_TYPE.BUY,
    transactionDate: '2025-12-15T19:10:00Z',
  },
];

export default mockTransactions;
